import { createSlice } from "@reduxjs/toolkit";
import { fetchPhoneNumberHealth } from "./whatsappThunk";

const initialState = {
  health: {
    quality_rating: null,
    messaging_limit_tier: null,
    name_status: null,
  },
  currentProjectId: null,
  loading: false,
  error: null,
};

const whatsappSlice = createSlice({
  name: "whatsapp",
  initialState,
  reducers: {
    resetHealth: (state, action) => {
      state.health = initialState.health;
      state.currentProjectId = action.payload || null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPhoneNumberHealth.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        // Optimization: We could set currentProjectId here or in fulfilled
        // But the Thunk arg is the projectId, so we can access it via meta.
        state.currentProjectId = action.meta.arg;
      })
      .addCase(fetchPhoneNumberHealth.fulfilled, (state, action) => {
        state.loading = false;
        state.health = action.payload;
        // set currentProjectId to ensure consistency
        state.currentProjectId = action.meta.arg;
      })
      .addCase(fetchPhoneNumberHealth.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        // Even if failed, we tried fetching for this project
        state.currentProjectId = action.meta.arg;
      });
  },
});

export const { resetHealth } = whatsappSlice.actions;
export default whatsappSlice.reducer;
